import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AppLayout from './components/AppLayout';
import Login from './pages/Login';
import AdminSignup from './pages/AdminSignup';
import MainAdminDashboard from './pages/MainAdminDashboard';
import HostelAdminDashboard from './pages/HostelAdminDashboard';
import TeamMemberDashboard from './pages/TeamMemberDashboard';
import HostelList from './pages/HostelList';
import HostelDetail from './pages/HostelDetail';
import BookingList from './pages/BookingList';
import TaskList from './pages/TaskList';
import RevenueSummary from './pages/RevenueSummary';
import EmployeePayments from './pages/EmployeePayments';
import BillsManagement from './pages/BillsManagement';

const theme = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 6,
  },
};

function App() {
  return (
    <ConfigProvider theme={theme}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin-signup" element={<AdminSignup />} />
            <Route
              path="/super-admin"
              element={
                <PrivateRoute requiredRole="super_admin">
                  <AppLayout><MainAdminDashboard /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/owner"
              element={
                <PrivateRoute requiredRole="owner">
                  <AppLayout><HostelAdminDashboard /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/employee"
              element={
                <PrivateRoute requiredRole="employee">
                  <AppLayout><TeamMemberDashboard /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/hostels"
              element={
                <PrivateRoute>
                  <AppLayout><HostelList /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/hostels/:id"
              element={
                <PrivateRoute>
                  <AppLayout><HostelDetail /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/bookings"
              element={
                <PrivateRoute allowedRoles={['owner', 'employee']}>
                  <AppLayout><BookingList /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/tasks"
              element={
                <PrivateRoute>
                  <AppLayout><TaskList /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/revenue"
              element={
                <PrivateRoute allowedRoles={['owner']}>
                  <AppLayout><RevenueSummary /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/employee-payments"
              element={
                <PrivateRoute allowedRoles={['owner', 'employee']}>
                  <AppLayout><EmployeePayments /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/bills"
              element={
                <PrivateRoute allowedRoles={['owner', 'employee']}>
                  <AppLayout><BillsManagement /></AppLayout>
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
